var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.running)?_c('div',{staticClass:"ajax-loading-animation"},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"subline inc"}),_c('div',{staticClass:"subline dec"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }